@if (footerContent$ | async; as footerContent) {
  <div
    class="flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-4 lg:gap-8 py-4 px-4 lg:py-6 lg:px-6 xl:px-24"
  >
    <div class="text-left lg:mx-auto basis-1/2">
      <h3 class="text-ss-brown max-lg:text-[18px] max-lg:mb-1">
        {{ footerContent.stayInTouchHeader }}
      </h3>
      <div
        class="text-ss-brown"
        [innerHTML]="footerContent.stayInTouchContent"
      ></div>
    </div>
    <form
      class="flex flex-col lg:flex-row w-full lg:justify-center basis-1/2 lg:items-center gap-4"
      [formGroup]="form"
    >
      <ss-form-field
        class="w-full text-ss-brown lg:basis-3/5 h-[90px]"
        label="Email address"
      >
        <input
          formControlName="emailAddress"
          ssInput
          ssForbiddenEmails
          class="text-[#382E2C]"
          ssBaseInput
        />
        <ss-form-field-error forError="email">
          Email address is invalid.
        </ss-form-field-error>
        <ss-form-field-error forError="maxlength">
          Email address is too long.
        </ss-form-field-error>
        <ss-form-field-error forError="forbiddenDomain">
          Your email provider is not supported
        </ss-form-field-error>
      </ss-form-field>
      <div class="justify-start flex lg:basis-2/5">
        <ss-button
          buttonColor="accent"
          buttonStyle="filled"
          class="w-full"
          (click)="signInClick()"
          >SIGN UP</ss-button
        >
      </div>
    </form>
  </div>
}
@if (showFormModal$ | async; as showFormModal) {
  @if (showFormModal.showModal) {
    <ss-www-stay-in-touch-form
      [openModal]="showFormModal.showModal"
      (openModalChange)="onOpenModalChange($event)"
      [emailInitialValue]="showFormModal.email"
      (formSubmit)="onFormSubmit($event)"
    >
    </ss-www-stay-in-touch-form>
  }
}

@if (isSubmitting()) {
  <ss-www-loading-modal>
    <h3 class="text-ss-brown">Submitting your subscription</h3>
    <p class="text-ss-brown">Please wait...</p>
  </ss-www-loading-modal>
}
